import {message} from "antd";
import {getWindflowServerBaseUrl} from "../data/api";

const WINDFLOW_SYSTEM_TOKEN = "WINDFLOW_SYSTEM_TOKEN"
const WINDFLOW_SYSTEM_ACCOUNT = "WINDFLOW_SYSTEM_ACCOUNT"

export function getToken(): string {
    let l = localStorage.getItem(WINDFLOW_SYSTEM_TOKEN)
    if (!l) {
        l = ""
    }
    return l
}

export function saveToken(newToken: string) {
    localStorage.setItem(WINDFLOW_SYSTEM_TOKEN, newToken);
}

export function getAccount(): string {
    let l = localStorage.getItem(WINDFLOW_SYSTEM_ACCOUNT)
    if (!l) {
        l = ""
    }
    return l
}

export function saveAccount(newAccount: string) {
    localStorage.setItem(WINDFLOW_SYSTEM_ACCOUNT, newAccount);
}


export function accountLogout() {
    localStorage.removeItem(WINDFLOW_SYSTEM_TOKEN);
}

export type SendCodeReq = {
    phone: string
}

export type SendCodeResp = {
    code: number
    msg: string
    data: string
}

export function sendCode(req: SendCodeReq, callback: (success: boolean, resp?: SendCodeResp) => void) {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(req),
    };

    fetch(getWindflowServerBaseUrl() + "/user/sendCode", options)
        .then(response => response.json())
        .then(res => {
            try {
                let resp = res as SendCodeResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                message.open({
                    type: 'error',
                    content: "Login failed",
                });
                callback(false, undefined);
            }
        })
}

export type LoginByCodeReq = {
    phone: string
    code: string
}

export type LoginData = {
    token: string
}

export type LoginResp = {
    code: number
    msg: string
    data: LoginData
}

export function loginByCode(req: LoginByCodeReq, callback: (success: boolean, resp?: LoginResp) => void) {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(req),
    };

    fetch(getWindflowServerBaseUrl() + "/user/loginByPhoneAndCode", options)
        .then(response => response.json())
        .then(res => {
            try {
                let resp = res as LoginResp;
                if (resp.code === 200) {
                    saveAccount(req.phone)
                    saveToken(resp.data.token)
                    callback(true, resp)
                    return
                }
                callback(resp.code === 200, resp);
            } catch (e) {
                message.open({
                    type: 'error',
                    content: "Login failed",
                });
                callback(false, undefined);
            }
        })
}
